module.exports = __webpack_public_path__ + "img/wx.b67905a3.jpg";